import Axios from 'axios';
import { isNowIncludeTimes, to2Digit } from './convertUtil';


/**
     * 초를 HH:MM 포맷으로 변경한다.
     * @param seconds
     * @returns {string}
     */
export const toTimeStamp = (seconds) => {
  let sysdate = new Date(seconds);
  let hh = sysdate.getHours();


  hh = (hh < 10) ? ('0' + hh) : hh;
  let mm = sysdate.getMinutes() < 10 ? ('0' + sysdate.getMinutes()) : sysdate.getMinutes();

  if (hh > 12) {
    hh -= 12;
    //hh = (hh < 10) ? ('0' + hh) : hh;
    hh = "오후 " + hh;
  } else if (hh == 12) {
    hh = "오후 " + hh;
  } else {
    //hh = (hh < 10) ? ('0' + hh) : hh;
    hh = "오전 " + hh;
  }

  let result = hh + ':' + mm;

  return result;
}
/**
 * 기존 온에어 함수(LIVE_UTIL)
 */

export const getPreviousScheduleItem = (scheduleArray, index) => {
  const simpleObj = {};
  const pre2PlanIndex = parseInt(index - 2);
  const pre1PlanIndex = parseInt(index - 1);

  simpleObj.homepage_url = null;
  simpleObj.starttime = scheduleArray[pre2PlanIndex]?.starttime || scheduleArray[pre1PlanIndex]?.starttime || null;
  simpleObj.endtime = scheduleArray[pre2PlanIndex]?.endtime || scheduleArray[pre1PlanIndex]?.starttime || null;
  simpleObj.title = scheduleArray[pre2PlanIndex]?.title || scheduleArray[pre2PlanIndex]?.title || '정보없음';

  return simpleObj;
}

/** 편성정보 불러오기.
 * @function
 * @param string
 * @returns {array}
 */
export const getLivePlanArray = async (channelId, isMobile) => {
  if (getLiveChannelType(channelId) === '24tv') {
    const virtualScheduleData = await Axios.get(`${process.env.API_LIVE_SCHEDULE_24TV}/${channelId}`)
      .then(request => request.data)
      .catch(x => console.error(x));
    const scheduleArray = virtualScheduleData?.list || [];
    scheduleArray.forEach(function (obj, index, array) {
      const temp = obj.date;
      obj.starttime_date = temp.substr(0, 10) + 'T' + temp.substr(11);
    });

    const plan = [];
    let isCurrent = false;

    for (let i = 0; i < scheduleArray.length; i++) {
      const current = new Date();
      const utc = current.getTime() + (current.getTimezoneOffset() * 60 * 1000);
      const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
      const korCurrent = new Date(utc + (KR_TIME_DIFF));

      if (new Date(scheduleArray[i].starttime_date).getTime() >= korCurrent.getTime() || getLiveChannelType(channelId) === '24tv') {
        // 편성표에 endtime이 없어서 계산하기 난해함. 아래같이 예외처리
        const simpleObj = {};
        simpleObj.homepage_url = null;
        simpleObj.starttime = scheduleArray[i].starttime;
        simpleObj.endtime = (scheduleArray[i].endtime === undefined) ? scheduleArray[i].starttime : scheduleArray[i].endtime;
        simpleObj.title = scheduleArray[i].title;

        // 기존 온에어와는 다르게 util에서 current 처리하여 전달
        if (getLiveChannelType(channelId) === '24tv') {
          // 정민규 과장 수정 - 24시간 채널의 편성표에서 현재 방송중인거는 무조건 배열의 1번 인덱스
          if (i === 1 && !isCurrent) {
            simpleObj.current = true;
            isCurrent = true;
          }
          if (!isMobile || i !== 0) {
            plan.push(simpleObj);
          }
        } else {
          if (plan.length === 0 && !isCurrent) {
            simpleObj.current = true;
            isCurrent = true;
          }
          if (!isMobile && plan.length === 0) {
            plan.push(getPreviousScheduleItem(scheduleArray, i));
          }
          plan.push(simpleObj);
        }


        if (plan.length > 14) {
          return plan;
        }
      }
    }
    return plan;

  } else {
    const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    const today = new Date();
    const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
    let _arrayYesterdayPlan = [];
    let _arrayTodayPlan = [];
    let _arrayTomorrowPlan = [];

    try {
      const planAPI = toPlanAPIUrl(channelId, yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      _arrayYesterdayPlan = await Axios.get(planAPI).then(request => request.data);
      _arrayYesterdayPlan.forEach(function (obj, index, array) {
        const temp = obj.start_time;
        if (parseInt(temp.substring(0, 2)) > 24 || (parseInt(temp.substring(0, 2)) === 24 && parseInt(temp.substring(3, 5)) > 0)) {
          const fixHHMM = to2Digit((parseInt(temp.substring(0, 2)) - 24).toString()) + ':' + temp.substring(3, 5);
          obj.starttime_date = new Date(today.getFullYear() + '-' + to2Digit(today.getMonth() + 1) + '-' + to2Digit(today.getDate()) + 'T' + fixHHMM);
          obj.starttime = fixHHMM;
        } else {
          obj.starttime_date = new Date(yesterday.getFullYear() + '-' + to2Digit(yesterday.getMonth() + 1) + '-' + to2Digit(yesterday.getDate()) + 'T' + temp);
          obj.starttime = temp;
        }
        if (Object.is(array.length - 1, index)) {
          obj.endtime = '';
        }
      });
    } catch (e) {
      console.error(e);
    }

    try {
      const planAPI = toPlanAPIUrl(channelId, today.getFullYear(), today.getMonth() + 1, today.getDate());
      _arrayTodayPlan = await Axios.get(planAPI).then(request => request.data);
      _arrayTodayPlan.forEach(function (obj, index, array) {
        const temp = obj.start_time;
        if (parseInt(temp.substring(0, 2)) > 24 || (parseInt(temp.substring(0, 2)) === 24 && parseInt(temp.substring(3, 5)) > 0)) {
          const fixHHMM = to2Digit((parseInt(temp.substring(0, 2)) - 24).toString()) + ':' + temp.substring(3, 5);
          obj.starttime_date = new Date(tomorrow.getFullYear() + '-' + to2Digit(tomorrow.getMonth() + 1) + '-' + to2Digit(tomorrow.getDate()) + 'T' + fixHHMM);
          obj.starttime = fixHHMM;
        } else {
          obj.starttime_date = new Date(today.getFullYear() + '-' + to2Digit(today.getMonth() + 1) + '-' + to2Digit(today.getDate()) + 'T' + temp);
          obj.starttime = temp;
        }
        if (Object.is(array.length - 1, index)) {
          obj.endtime = '';
        }
      });
    } catch (e) {
      console.error(e);
    }

    try {
      const planAPI = toPlanAPIUrl(channelId, tomorrow.getFullYear(), tomorrow.getMonth() + 1, tomorrow.getDate());
      _arrayTomorrowPlan = await Axios.get(planAPI).then(request => request.data);
      _arrayTomorrowPlan.forEach(function (obj, index, array) {
        const temp = obj.start_time;
        if (parseInt(temp.substring(0, 2)) > 24 || (parseInt(temp.substring(0, 2)) === 24 && parseInt(temp.substring(3, 5)) > 0)) {
          // 모레 데이터로 치환하지 않음 invalid date 유도
        } else {
          obj.starttime_date = new Date(tomorrow.getFullYear() + '-' + to2Digit(tomorrow.getMonth() + 1) + '-' + to2Digit(tomorrow.getDate()) + 'T' + temp);
          obj.starttime = temp;
        }
        if (Object.is(array.length - 1, index)) {
          obj.endtime = '';
        }
      });
    } catch (e) {
      console.error(e);
    }

    const result = await Promise.all([_arrayYesterdayPlan, _arrayTodayPlan, _arrayTomorrowPlan]).then(function (values) {
      const array3daysPlan = values[0].concat(values[1]).concat(values[2]);
      const plan = [];
      let isCurrent = false;
      for (let i = 0; i < array3daysPlan.length; i++) {
        // 10분 전 방송 프로그램만 가져옴

        const current = new Date();
        const utc = current.getTime() + (current.getTimezoneOffset() * 60 * 1000);
        const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
        const korCurrent = new Date(utc + (KR_TIME_DIFF));

        if (new Date(array3daysPlan[i].starttime_date).getTime() >= korCurrent.getTime()) {
          // 편성표에 endtime이 없어서 계산하기 난해함. 아래같이 예외처리
          const simpleObj = {};
          simpleObj.homepage_url = array3daysPlan[i - 1].homepage_url;
          simpleObj.starttime = array3daysPlan[i - 1].starttime || '';
          simpleObj.endtime = (array3daysPlan[i - 1].endtime === undefined) ? array3daysPlan[i].starttime || '' : array3daysPlan[i - 1].endtime || '';
          simpleObj.title = array3daysPlan[i - 1].title || '정보없음';

          // 기존 온에어와는 다르게 util에서 current 처리하여 전달
          //if (isNowIncludeTimes(simpleObj.starttime, simpleObj.endtime) && !isCurrent) {
          if (plan.length === 0 && !isCurrent) {
            simpleObj.current = true;
            isCurrent = true;
          }
          try {
            if (!isMobile && plan.length === 0) {
              plan.push(getPreviousScheduleItem(array3daysPlan, i));
            }
          } catch (e) {

          }

          plan.push(simpleObj);
          if (plan.length > 14) return plan;
        }
      }
      return plan;
    }).catch(function (error) {
      console.error(error);
    });
    return result;
  }
};

/** 채널타입 확인.
 * @function
 * @param string
 * @returns {string}
 */
export const getLiveChannelType = (channelId) => {
  let type;
  switch (channelId) {
    case 'S01':
    case 'S02':
    case 'S03':
    case 'S04':
    case 'S05':
    case 'S06':
    case 'S09':
    case 'S10':
    case 'S11':
    case 'S12':
    case 'S20':
    case 'EVENT':
    case 'EVENT1':
    case 'EVENT2':
    case 'EVENT3':
    case 'EVENT4':
      type = 'tv';
      break;
    case 'S07':
    case 'S17':
    case 'S08':
    case 'S18':
    case 'S19':
      type = 'radio';
      break;
    default:
      type = '24tv';
      break;
  }
  return type;
};

export const getLiveChannelTypeName = (channelId) => {
  let name;
  switch (channelId) {
    case 'S01':
    case 'S02':
    case 'S03':
    case 'S04':
    case 'S05':
    case 'S06':
    case 'S09':
    case 'S10':
    case 'S11':
    case 'S12':
    case 'S20':
    case 'EVENT':
    case 'EVENT1':
    case 'EVENT2':
    case 'EVENT3':
    case 'EVENT4':
      name = '라이브 TV';
      break;
    case 'S07':
    case 'S17':
    case 'S08':
    case 'S18':
    case 'S19':
      name = '라이브 라디오';
      break;
    default:
      name = '24시간 TV';
      break;
  }
  return name;
};

/** 채널아이디가 가상채널인지 확인.
 * @function
 * @param string
 * @returns {Boolean}
 */
export const isVirtualChannel = (channelId) => {
  switch (channelId) {
    case 'S01':
    case 'S02':
    case 'S03':
    case 'S04':
    case 'S05':
    case 'S06':
    case 'S07':
    case 'S08':
    case 'S09':
    case 'S10':
    case 'S11':
    case 'S12':
    case 'S17':
    case 'S18':
    case 'S19':
    case 'S20':
    case 'EVENT':
    case 'EVENT1':
    case 'EVENT2':
    case 'EVENT3':
    case 'EVENT4':
      return false;
    default:
      return true;
  }
};
/**
 * 편성표 API 조회
 * @function
 * @param string
 * @returns {String}
 */
export const toPlanUrl = (channelId) => {
  let result;
  switch (channelId) {
    case 'tv':
    case 'S01':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=SBS`;
      break;
    case 'S02':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=ESPN`;
      break;
    case 'S03':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=Plus`;
      break;
    case 'S04':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=ETV`;
      break;
    case 'S05':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=Golf`;
      break;
    case 'S12':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=Golf2`;
      break;
    case 'S06':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=CNBC`;
      break;
    case 'S07':
    case 'S17':
      result = `https://www.sbs.co.kr/schedule/index.html?type=ra&channel=Power`;
      break;
    case 'radio':
    case 'S08':
    case 'S18':
      result = `https://www.sbs.co.kr/schedule/index.html?type=ra&channel=Love`;
      break;
    case 'S09':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=MTV`;
      break;
    case 'S10':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=Nick`;
      break;
    case 'S11':
      result = `https://www.sbs.co.kr/schedule/index.html?type=tv&channel=Fil`;
      break;
    case 'S19':
      result = `https://www.sbs.co.kr/schedule/index.html?type=ra&channel=DMB+Radio`;
      break;
    default:
      result = `https://www.sbs.co.kr/schedule/index.html?div=pc_scheduler`;
      break;
  }
  return result;
};
/**
   * 채널별 편성표 API 조회.
   * @function
   * @param string
   * @param string
   * @returns {String}
   */
export const toPlanAPIUrl = (channelId, yyyy, mm, dd) => {
  let result;
  switch (channelId) {
    case 'S01':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/SBS.json`;
      break;
    case 'S02':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/ESPN.json`;
      break;
    case 'S03':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Plus.json`;
      break;
    case 'S04':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/ETV.json`;
      break;
    case 'S05':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Golf.json`;
      break;
    case 'S12':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Golf2.json`;
      break;
    case 'S06':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/CNBC.json`;
      break;
    case 'S07':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Power.json`;
      break;
    case 'S17':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Power.json`;
      break;
    case 'S08':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Love.json`;
      break;
    case 'S18':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Love.json`;
      break;
    case 'S09':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/MTV.json`;
      break;
    case 'S10':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Nick.json`;
      break;
    case 'S11':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/Fil.json`;
      break;
    case 'S19':
      result = `${process.env.API_LIVE_SCHEDULE}/${yyyy}/${mm}/${dd}/DMB+Radio.json`;
      break;
    default:
      result = null;
      break;
  }
  return result;
};


export const getMsg = (text) => {
  try {
    if (typeof text === 'string' && text.indexOf('{') > -1) {
      text = text.replace('"{', '{');
      text = text.replace('}"', '}');
      return JSON.parse(text).msg;
    } else {
      return text;
    }
  } catch (e) {
    return text;
  }

}
export const getImg = (text) => {
  try {
    if (typeof text === 'string' && text.indexOf('{') > -1) {
      text = text.replace('"{', '{');
      text = text.replace('}"', '}');
      if (JSON.parse(text).emoticon_pc !== undefined && JSON.parse(text).emoticon_pc.length > 0) {
        return decodeURIComponent(JSON.parse(text).emoticon_pc);
      } else if (JSON.parse(text).emoticon !== undefined && JSON.parse(text).emoticon.length > 0) {
        //잘못된 데이터이지만 노출함.
        return decodeURIComponent(JSON.parse(text).emoticon);
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }

}